module.exports = __webpack_public_path__ + "static/team1-9f4b3d1c105e4219d0cb9dfa4a14e64f.jpg";